import React from "react";
import { withTranslation } from "react-i18next";
// import styles from "./ReviewSummaryView.module.scss";
// import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { humanReadableDate } from "../../../../helpers/utils";

const AnotherAdultSummary = ({
  t,
  i18n,
  setIsError,
  otherAdultInformation,
  otherAdultAssessmentFiles
}) => {
  // let navigate = useNavigate();

  // const { questionDataList } = useSelector((state) => state.app);

  const { dateOfBirth } = otherAdultInformation;
  const otherAdultName =
    otherAdultInformation.firstName + " " + otherAdultInformation.lastName;

  const otherAdultSin = otherAdultInformation.socialInsuranceNumber;
  const findAssessmentDoc = (id) => {
    for (let key in otherAdultAssessmentFiles) {
      if (key == id) {
        return otherAdultAssessmentFiles[key][0].name
      }
    }
  }
  // const dobEn =
  //   questionDataList[
  //     questionDataList.findIndex((question) => question.questionNumber === 9)
  //   ].questionAnswer;

  const dob =
    i18n.language === "fr"
      ? new Date(dateOfBirth).toLocaleString("fr-FR", {
        month: "long",
        day: "numeric",
        year: "numeric"
      })
      : humanReadableDate(dateOfBirth);

  // const editOtherAdultOnClick = (e) => {
  //   e.preventDefault();
  //   try {
  //     navigate(`/${i18n.language}${t("routes.other_adults_form")}?isSummary=true`);
  //   } catch (e) {
  //     console.log(e);
  //     setIsError(true);
  //   }
  // };

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.another_adult_section1")}</strong>
            </div>
            <div className="col-xs-12 col-md-6">{otherAdultName}</div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.another_adult_section2")}</strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {`xxx xxx ` + otherAdultSin.substr(otherAdultSin.length - 3)}
            </div>
          </div>
          <hr />
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section3")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">{dob}</div>
          </div>
          <hr />
          {findAssessmentDoc(otherAdultInformation.localId) &&
            <><div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="col-xs-12 col-md-6">
                <strong>
                  {t("other_adult_living_form.uploaded_assessment_lable")}
                </strong>
              </div>
              <div className="col-xs-12 col-md-6">{findAssessmentDoc(otherAdultInformation.localId)}</div>
            </div>
              <hr /></>}
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(AnotherAdultSummary);
